import * as actionTypes from "../actions/actionTypes";

const initialState = {
  comunicaciones: [],
  errorMsg: "",
  currentCommunication: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_COMUNICACIONES: {
      return {
        ...state,
        comunicaciones: action.comunicaciones,
        errorMsg: "",
      };
    }
    case actionTypes.SET_COMUNICACIONES_FAILED: {
      return {
        ...state,
        errorMsg: action.errorMsg,
      };
    }
    case actionTypes.UPDATE_COMUNICACIONES: {
      const updatedComunicaciones = [...state.comunicaciones];
      const ids = action.Ids;
      ids.forEach((id) => {
        const index = updatedComunicaciones.findIndex((c) => c.id === id);
        if (index !== -1) {
          updatedComunicaciones[index] = {
            ...updatedComunicaciones[index],
            leidoPortal: "S"
          };
        }
      });
      return {
        ...state,
        comunicaciones: updatedComunicaciones,
        errorMsg: "",
      };
    }
    case actionTypes.UPDATE_COMUNICACIONES_FAILED: {
      return {
        ...state,
        errorMsg: action.error,
      };
    }
    case actionTypes.SET_CURRENT_COMMUNICATION: {
      return {
        ...state,
        currentCommunication: action.communication,
      };
    }
    default:
      return state;
  }
};

export default reducer;
